// Generated by purs version 0.15.0
import * as Affjax_RequestHeader from "../Affjax.RequestHeader/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Effect_Aff from "../Effect.Aff/index.js";
import * as Effect_Aff_Class from "../Effect.Aff.Class/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Network_JsonRPC from "../Network.JsonRPC/index.js";
import * as Restaumatic_I18nWrapper from "../Restaumatic.I18nWrapper/index.js";
import * as Restaumatic_Locales from "../Restaumatic.Locales/index.js";
import * as Restaumatic_Orders_Payments_RPC_Sites_Types from "../Restaumatic.Orders.Payments.RPC.Sites.Types/index.js";
import * as Restaumatic_Orders_RPC_Sites_Types from "../Restaumatic.Orders.RPC.Sites.Types/index.js";
import * as Restaumatic_Restaurants_RPC_Sites_Types from "../Restaumatic.Restaurants.RPC.Sites.Types/index.js";
import * as Restaumatic_Restaurants_Types from "../Restaumatic.Restaurants.Types/index.js";
var sitesRPC = function (dictEncode) {
    return function (dictDecode) {
        return function (dictRPCMethodName) {
            return function (req) {
                return Control_Bind.bind(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Restaumatic_I18nWrapper.getGlobalLocale))(function (locale) {
                    return Network_JsonRPC.rpc(dictRPCMethodName)(Effect_Aff.monadAff)(Network_JsonRPC.runAffjax(dictEncode)(dictDecode)("/api/v1/sites/rpc")([ new Affjax_RequestHeader.RequestHeader("x-app-locale", Data_Show.show(Restaumatic_Locales.showLocale)(locale)) ]))(req);
                });
            };
        };
    };
};
var placeOrder = /* #__PURE__ */ (function () {
    var $3 = Effect_Aff_Class.liftAff(Effect_Aff_Class.monadAffAff);
    var $4 = sitesRPC(Network_JsonRPC.encodeRequest(Restaumatic_Orders_RPC_Sites_Types.encodePlaceOrderRequest)(Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Orders_RPC_Sites_Types.encodePlaceOrderRequest)))(Network_JsonRPC.decodeResponse(Restaumatic_Orders_RPC_Sites_Types.decodePlaceOrderResponse))(Restaumatic_Orders_RPC_Sites_Types.rpcMethodNamePlaceOrderRequest);
    return function ($5) {
        return $3($4($5));
    };
})();
var getPaymentChannels = /* #__PURE__ */ (function () {
    var $6 = Effect_Aff_Class.liftAff(Effect_Aff_Class.monadAffAff);
    var $7 = sitesRPC(Network_JsonRPC.encodeRequest(Restaumatic_Orders_Payments_RPC_Sites_Types.encodeGetPaymentChannelsRequest)(Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Orders_Payments_RPC_Sites_Types.encodeGetPaymentChannelsRequest)))(Network_JsonRPC.decodeResponse(Restaumatic_Orders_Payments_RPC_Sites_Types.decodeGetPaymentChannelsResponse))(Restaumatic_Orders_Payments_RPC_Sites_Types.rpcMethodNameGetPaymentChannelsRequest);
    return function ($8) {
        return $6($7($8));
    };
})();
var getOrderingAvailability = /* #__PURE__ */ (function () {
    var $9 = Effect_Aff_Class.liftAff(Effect_Aff_Class.monadAffAff);
    var $10 = sitesRPC(Network_JsonRPC.encodeRequest(Restaumatic_Restaurants_RPC_Sites_Types.encodeGetOrderingAvailabilityRequest)(Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Restaurants_RPC_Sites_Types.encodeGetOrderingAvailabilityRequest)))(Network_JsonRPC.decodeResponse(Restaumatic_Restaurants_Types.decodeOrderingAvailability))(Restaumatic_Restaurants_RPC_Sites_Types.rpcMethodNameGetOrderingAvailabilityRequest);
    return function ($11) {
        return $9($10($11));
    };
})();
var getOrderSummary = /* #__PURE__ */ (function () {
    var $12 = Effect_Aff_Class.liftAff(Effect_Aff_Class.monadAffAff);
    var $13 = sitesRPC(Network_JsonRPC.encodeRequest(Restaumatic_Orders_RPC_Sites_Types.encodeGetOrderSummaryRequest)(Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Orders_RPC_Sites_Types.encodeGetOrderSummaryRequest)))(Network_JsonRPC.decodeResponse(Restaumatic_Orders_RPC_Sites_Types.decodeGetOrderSummaryResponse))(Restaumatic_Orders_RPC_Sites_Types.rpcMethodNameGetOrderSummaryRequest);
    return function ($14) {
        return $12($13($14));
    };
})();
var getCheckoutInfo = /* #__PURE__ */ (function () {
    var $15 = Effect_Aff_Class.liftAff(Effect_Aff_Class.monadAffAff);
    var $16 = sitesRPC(Network_JsonRPC.encodeRequest(Restaumatic_Orders_RPC_Sites_Types.encodeGetCheckoutInfoRequest)(Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Orders_RPC_Sites_Types.encodeGetCheckoutInfoRequest)))(Network_JsonRPC.decodeResponse(Restaumatic_Orders_RPC_Sites_Types.decodeCheckoutInfo))(Restaumatic_Orders_RPC_Sites_Types.rpcMethodNameGetCheckoutInfoRequest);
    return function ($17) {
        return $15($16($17));
    };
})();
export {
    getCheckoutInfo,
    getOrderSummary,
    getOrderingAvailability,
    getPaymentChannels,
    placeOrder,
    sitesRPC
};
export {
    GetPaymentChannelsRequest,
    GetPaymentChannelsResponse
} from "../Restaumatic.Orders.Payments.RPC.Sites.Types/index.js";
export {
    CheckoutInfo,
    FulfillmentTimeChoice,
    GetCheckoutInfoRequest,
    GetOrderSummaryRequest,
    GetOrderSummaryResponse,
    Cancelled,
    Completed,
    Placed,
    WaitingForConfirmation,
    WaitingForDispatch,
    WaitingForPayment,
    PlaceOrderRequest,
    Errors,
    ExternalRedirect,
    PaymentForm,
    Redirect,
    encodingOpts
} from "../Restaumatic.Orders.RPC.Sites.Types/index.js";
//# sourceMappingURL=index.js.map
